import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Alert } from "reactstrap";

const STATUS = {
  idle: { color: "info", icon: "fa-info-circle" },
  info: { color: "info", icon: "fa-info-circle" },
  validated: { color: "success", icon: "fa-check-circle" },
  conflict: { color: "warning", icon: "fa-exclamation-triangle" },
  error: { color: "danger", icon: "fa-exclamation-triangle" },
};

/**
 * Mensaje del resultado de una validación (documento, RNC, identidad).
 * Reemplaza los "*-feedback" con is-validated / is-conflict / is-error.
 *
 * <ValidationFeedback status={validation.status}>{validation.message}</ValidationFeedback>
 */
export default function ValidationFeedback({ children, className, status }) {
  const { color, icon } = STATUS[status] || STATUS.info;

  return (
    <Alert
      color={color}
      className={classnames("d-flex align-items-start mb-0", className)}
    >
      <i className={classnames("fa mr-2 mt-1", icon)} aria-hidden="true" />
      <div>{children}</div>
    </Alert>
  );
}

ValidationFeedback.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  status: PropTypes.oneOf(Object.keys(STATUS)),
};

ValidationFeedback.defaultProps = {
  status: "info",
};
